<template>
  <form
    @submit.prevent="handleSubmit"
    @change="handleChange"
    @invalid.capture.prevent="handleInvalid"
  >
    <v-alert icon="notification">
      Please note that any changes made will have to be approved by NATA before being applied to this portal.
    </v-alert>
    <v-fieldset
      id="notification_title"
      v-model="notification.notification_title"
      name="notification_title"
      text="Subject"
      type="text"
      is-required
      :help-text="fieldErrors.notification_title"
    />
    <v-fieldset
      id="notification_body"
      v-model="notification.notification_body"
      name="notification_body"
      text="What is your message about?"
      type="textarea"
      is-required
      :help-text="fieldErrors.notification_body"
    />

    <v-button
      size="lg"
      class="mt-auto"
      has-min-width
      is-submit
    >
      Send
    </v-button>
  </form>
</template>
<script>
  import Alert from "@/atoms/Alert";
  import Button from "@/atoms/Button";
  import Fieldset from "@/molecules/Fieldset";
  import {SEND_NOTIFICATION} from "@/store/actions.type";

  export default {
    name: "ContactForm",
    components: {
      'v-button': Button,
      'v-alert': Alert,
      'v-fieldset': Fieldset,
    },
    data: () => ({
      subject: '',
      body: '',
      hasSent: false,
      fieldErrors: {},
      notification: {
        type: 'user',
        notification_title: '',
        notification_body: '',
        notification_sender_username: '',
        notification_sender_email: '',
      },
      contact: [
        {value: '1800 621 666 (free call)', icon: 'phone'},
        {value: 'portalsupport@nata.com.au', icon: 'envelope'},
        {value: '7 Leeds St, Rhodes NSW 2138', icon: 'map-marker'},
        {value: 'www.nata.com.au', icon: 'user'},
      ]
    }),
    methods: {
      handleSubmit() {
        //set the notification sender before sending off the notification
        let user = this.$store.getters.getUser;
        let username = user.first_name ? user.first_name + ' ' + user.last_name:''
        let userEmail = user.email;
        this.notification.notification_sender_username = username;
        this.notification.notification_sender_email = userEmail;
        //send the notification
        this.$store.dispatch(SEND_NOTIFICATION, this.notification).then(response => {
          this.$emit('sent', true);
          this.notification.notification_body = '';
          this.notification.notification_title = '';
          this.notification.notification_sender_username = '';
          this.notification.notification_sender_email = '';
        })
          .catch(error => {
            this.$notify({
              title: 'Error:',
              text: 'Send notification goes wrong!',
              type: 'error'
            })
          })
      },
      handleChange(evt) {
        this.fieldErrors = {
          ...this.fieldErrors,
          [evt.target.name]: ""
        };
      },
      handleInvalid(evt) {
        this.fieldErrors = {
          ...this.fieldErrors,
          [evt.target.name]: evt.target.validationMessage
        };
      }
    }
  }
</script>

